import { Brand, createBranded } from '@deltasierra/type-utilities';

export type TemplateSettingsId = Brand<number, 'TemplateSettingsId'>;
export const TemplateSettingsId = createBranded<TemplateSettingsId>();
